import ReducerEntityPrefixTypes from "../../../../../enums/reducer/reducerEntityPrefixTypes";
import ReducerNamespaceTypes from "../../../../../enums/reducer/reducerNamespaceTypes";
import {
  createFetchingItemsSlice,
  type FetchingItemsState,
} from "../../../../Application/slices/createFetchingItemsSlice";
import { type LicenseConfirmationItem } from "../../../../../interfaces";

export interface LicenseConfirmationState extends FetchingItemsState<LicenseConfirmationItem> {
  isPurchaseNeeded: boolean;
}

export const initialState: LicenseConfirmationState = {
  items: [],
  itemsCount: 0,
  isPurchaseNeeded: false,
  isLoading: false,
  error: undefined,
};

const licenseConfirmationSlice = createFetchingItemsSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Licensing,
    entity: ReducerEntityPrefixTypes.AvailableLicenses,
    name: "availableLicenses",
  },
  initialState,
  reducers: {
    setIsPurchaseNeeded: (state, action) => {
      state.isPurchaseNeeded = action.payload;
    },
  },
});

export const { fetchBegin, fetchSuccess, fetchFailure, reset, setIsPurchaseNeeded } = licenseConfirmationSlice.actions;

export default licenseConfirmationSlice.reducer;
